export enum EAnalyticsEvents {
  DASHBOARD_DOWNLOAD = 'Dashboard_download',
  TALENT_CARD_DOWNLOAD = 'Talent_card_download',
  ELIGIBILITY_CHANGE_NO = 'Eligibility_change_no',
  ELIGIBILITY_CHANGE_YES = 'Eligibility_change_yes',
  MEETING_START = 'Meeting_start',
  MEETING_ADD_PARTICIPANT = 'Meeting_add_participant',
  TALENT_CARD_2AS_AMBITIONS_EDIT = 'Talent_card_2as_ambitions_edit',
  TALENT_CARD_2AS_AMBITIONS_PUBLISH = 'Talent_card_2as_ambitions_publish',
  TALENT_CARD_2AS_ACHIEVEMENTS_EDIT = 'Talent_card_2as_achievements_edit',
  TALENT_CARD_2AS_ACHIEVEMENTS_PUBLISH = 'Talent_card_2as_achievements_publish',
  TALENT_CARD_ABOUT_ME_EDIT = 'Talent_card_about_me_edit',
  TALENT_CARD_ABOUT_ME_PUBLISH = 'Talent_card_about_me_publish',
  TALENT_CARD_WORKDAY_EDIT = 'Talent_card_workday_edit',
  TALENT_CARD_REFRESH = 'Talent_card_refresh',
  TALENT_CARD_FULLSCREEN_OPEN = 'Talent_card_fullscreen_open',
  TALENT_CARD_FULLSCREEN_CLOSE = 'Talent_card_fullscreen_close',
  DOWNLOAD_MEETING_DETAILS_REPORT = 'Download_meeting_details_report',
  DOCUMENT_DOWNLOAD = 'Document_download',
  DOCUMENT_FILTER_BY_MODULE = 'Document_filter_by_module',
  DOCUMENT_CLEAR_FILTERS = 'Document_clear_filters',
  DOCUMENT_SEARCH_BY_NAME = 'Document_search_by_name',
  DOCUMENT_SORT = 'Document_sort',
  DOCUMENT_PAGE_CHANGE = 'Document_page_change',
  MANAGER_FEEDBACK_SELECT_EMPLOYEE = 'Manager_feedback_select_employee',
  MANAGER_FEEDBACK_FILTER_STATUS = 'Manager_feedback_filter_status',
  MANAGER_FEEDBACK_FILTER_SUBORDINATES = 'Manager_feedback_filter_subordinates',
  MANAGER_FEEDBACK_FILTER_ELIGIBLE = 'Manager_feedback_filter_eligible',
  MANAGER_FEEDBACK_SEARCH_EMPLOYEE = 'Manager_feedback_search_employee',
  MANAGER_FEEDBACK_SEARCH_MANAGER = 'Manager_feedback_search_manager',
  MANAGER_FEEDBACK_ASSERT = 'Manager_feedback_assert',
  MEETING_LIST_FILTER_DATE = 'Meeting_list_filter_date',
  MEETING_LIST_FILTER_OWNER = 'Meeting_list_filter_owner',
  MEETING_LIST_FILTER_ZONE = 'Meeting_list_filter_zone',
  MEETING_LIST_FILTER_YEAR = 'Meeting_list_filter_year',
  MEETING_LIST_FILTER_TEMPLATE = 'Meeting_list_filter_template',
  MEETING_LIST_CLEAR_FILTERS = 'Meeting_list_clear_filters',
  MEETING_LIST_APPLY_FILTERS = 'Meeting_list_apply_filters',
  MEETING_LIST_SORT = 'Meeting_list_sort',
  MEETING_LIST_COPY_ID = 'Meeting_list_copy_id',
  MEETING_LIST_OPEN_MEETING = 'Meeting_list_open_meeting',
  MEETING_LIST_SEARCH = 'Meeting_list_search',
  MEETING_LIST_FILTER_STATUS = 'Meeting_list_filter_status',
  MEETING_LIST_CREATE = 'Meeting_list_create',
  MEETING_CREATE = 'Meeting_create',
  MEETING_START_VOTING = 'Meeting_start_voting',
  MEETING_STOP_VOTING = 'Meeting_stop_voting',
  MEETING_END = 'Meeting_end',
  MEETING_DELETE = 'Meeting_delete',
  MEETING_DELETE_PARTICIPANTS = 'Meeting_delete_participants',
  MEETING_RATE_PARTICIPANT = 'Meeting_rate_participant',
  MEETING_SAVE_OPR_VOTE = 'Meeting_save_opr_vote',
  MEETING_SAVE_ADDITIONAL_VOTE = 'Meeting_save_additional_vote',
  MEETING_SAVE_MASS_VOTE = 'Meeting_save_mass_vote',
  MEETING_SAVE_REMAINING_VOTE = 'Meeting_save_remaining_vote',
  MEETING_SAVE_NOMINATION_DETAILS = 'Meeting_save_nomination_details',
  MEETING_ADD_PARTICIPANT_SINGLE = 'Meeting_add_participant_single',
  MEETING_ADD_PARTICIPANTS_BULK = 'Meeting_add_participants_bulk',
  MEETING_REMOVE_PARTICIPANT = 'Meeting_remove_participant',
  MEETING_RENAME = 'Meeting_rename',
  MEETING_FILTER_PARTICIPANTS = 'Meeting_filter_participants',
  MEETING_CLEAR_PARTICIPANT_FILTERS = 'Meeting_clear_participant_filters',
  MEETING_APPLY_PARTICIPANT_FILTERS = 'Meeting_apply_participant_filters',
  MEETING_START_MEETING = 'Meeting_start_meeting',
  MEETING_EXPORT_PARTICIPANTS = 'Meeting_export_participants',
  MEETING_SEARCH_PARTICIPANTS = 'Meeting_search_participants',
  MEETING_SORT_PARTICIPANTS = 'Meeting_sort_participants',
  MEETING_COPY_OPR_RATINGS = 'Meeting_copy_opr_ratings',
  MEETING_DOWNLOAD_TALENT_CARDS = 'Meeting_download_talent_cards',
  MEETING_SHAPES_FILTER_OPR_RATE = 'Meeting_shapes_filter_opr_rate',
  MEETING_SHAPES_FILTER_SECONDARY = 'Meeting_shapes_filter_secondary',
  MEETING_OVERVIEW_TALENT_POOL = 'Meeting_overview_talent_pool',
  MEETING_TOGGLE_FILTERS = 'Meeting_toggle_filters',
  MEETING_PAGE_CHANGE = 'Meeting_page_change',
  MEETING_SELECT_PARTICIPANT = 'Meeting_select_participant',
  MEETING_SELECT_ALL_PARTICIPANTS = 'Meeting_select_all_participants',
  MEETING_OPEN_EDIT_TITLE = 'Meeting_open_edit_title',
  MEETING_OPEN_RATE_PARTICIPANT = 'Meeting_open_rate_participant',
  MEETING_VIEW_LATEST_RATE = 'Meeting_view_latest_rate',
  MEETING_VIEW_NOMINATION_DETAILS = 'Meeting_view_nomination_details',
  MEETING_VIEW_PARTICIPANT_DETAIL = 'Meeting_view_participant_detail',
  MEETING_OPEN_DISCUSSION = 'Meeting_open_discussion',
  MEETING_CLEAR_QUERY_FILTER = 'Meeting_clear_query_filter',
  MEETING_CLEAR_MANAGER_FILTER = 'Meeting_clear_manager_filter',
  MEETING_OPEN_SETTINGS = 'Meeting_open_settings',
  MEETING_VOTE_FOR_REMAINING = 'Meeting_vote_for_remaining',
  MEETING_MASS_VOTE = 'Meeting_mass_vote',
  MEETING_RATE_PARTICIPANT_WITH_NOMINATIONS = 'Meeting_rate_participant_with_nominations',
  MEETING_OVERVIEW_FILTER_RATE_ORIGIN = 'Meeting_overview_filter_rate_origin',
  MEETING_EDIT_OPEN_ADD_DIALOG = 'Meeting_edit_open_add_dialog',
  MEETING_EDIT_SEARCH_EMPLOYEES = 'Meeting_edit_search_employees',
  MEETING_EDIT_CLEAR_EMPLOYEE_FILTERS = 'Meeting_edit_clear_employee_filters',
  MEETING_EDIT_TOGGLE_FULL_SCOPE = 'Meeting_edit_toggle_full_scope',
  MEETING_EDIT_CLOSE_ADD_DIALOG = 'Meeting_edit_close_add_dialog',
  MEETING_EDIT_SEARCH_PARTICIPANTS_LIST = 'Meeting_edit_search_participants_list',
  MEETING_EDIT_NAME_SUBMIT = 'Meeting_edit_name_submit',
  MEETING_SHAPES_BACK_TO_MEETING = 'Meeting_shapes_back_to_meeting',
  SUCCESSION_SELECT_POSITION = 'Succession_select_position',
  SUCCESSION_FILTER_CHANGE = 'Succession_filter_change',
  SUCCESSION_FILTER_UNFILLED_PLAN = 'Succession_filter_unfilled_plan',
  SUCCESSION_CLEAR_FILTERS = 'Succession_clear_filters',
  SUCCESSION_TOGGLE_FILTER_PANEL = 'Succession_toggle_filter_panel',
  SUCCESSION_EXPORT_PLANS = 'Succession_export_plans',
  SUCCESSION_OPEN_PROCESS_DETAIL = 'Succession_open_process_detail',
  SUCCESSION_CHANGE_PROCESS_TRACKING = 'Succession_change_process_tracking',
  SUCCESSION_SAVE_CHANGES = 'Succession_save_changes',
  SUCCESSION_LOCK_UNLOCK_POSITION = 'Succession_lock_unlock_position',
  SUCCESSION_DOWNLOAD_PLAN = 'Succession_download_plan',
  SUCCESSION_VIEW_HISTORY = 'Succession_view_history',
  SUCCESSION_ADD_SUCCESSOR = 'Succession_add_successor',
  SUCCESSION_ADD_MULTIPLE_SUCCESSORS = 'Succession_add_multiple_successors',
  SUCCESSION_GO_EXTERNAL = 'Succession_go_external',
  SUCCESSION_SEARCH_EMPLOYEES = 'Succession_search_employees',
  SUCCESSION_VIEW_SUCCESSOR_DETAIL = 'Succession_view_successor_detail',
  SUCCESSION_REMOVE_SUCCESSOR = 'Succession_remove_successor',
  SUCCESSION_DRAG_DROP_SUCCESSOR = 'Succession_drag_drop_successor',
  SUCCESSION_OPEN_ADD_SUCCESSOR_DIALOG = 'Succession_open_add_successor_dialog',
  SUCCESSION_SORT_SUCCESSOR = 'Succession_sort_successor',
  SUCCESSION_VIEW_REMOVAL_REASON = 'Succession_view_removal_reason',
  TALENT_POOL_MANAGEMENT_SEARCH_EMPLOYEE = 'Talent_pool_management_search_employee',
  TALENT_POOL_MANAGEMENT_CLEAR_SEARCH = 'Talent_pool_management_clear_search',
  TALENT_POOL_MANAGEMENT_SORT = 'Talent_pool_management_sort',
  TALENT_POOL_MANAGEMENT_PAGE_CHANGE = 'Talent_pool_management_page_change',
  TALENT_POOL_MANAGEMENT_OPEN_EDIT_DIALOG = 'Talent_pool_management_open_edit_dialog',
  TALENT_POOL_MANAGEMENT_EDIT_OPEN_ADD_POOL = 'Talent_pool_management_edit_open_add_pool',
  TALENT_POOL_MANAGEMENT_EDIT_SELECT_POOL_TYPE = 'Talent_pool_management_edit_select_pool_type',
  TALENT_POOL_MANAGEMENT_EDIT_SELECT_POOL_YEAR = 'Talent_pool_management_edit_select_pool_year',
  TALENT_POOL_MANAGEMENT_EDIT_SAVE_POOL = 'Talent_pool_management_edit_save_pool',
  TALENT_POOL_MANAGEMENT_EDIT_DELETE_POOL = 'Talent_pool_management_edit_delete_pool',
  TALENT_POOL_MANAGEMENT_EDIT_CLOSE = 'Talent_pool_management_edit_close',
  ROLE_SETTING_SEARCH_EMPLOYEE = 'Role_setting_search_employee',
  ROLE_SETTING_SEARCH_MANAGER = 'Role_setting_search_manager',
  ROLE_SETTING_FILTER_BY_ROLE = 'Role_setting_filter_by_role',
  ROLE_SETTING_SELECT_EMPLOYEE = 'Role_setting_select_employee',
  ROLE_SETTING_CHANGE_ROLE = 'Role_setting_change_role',
  ROLE_SETTING_SAVE_ROLE = 'Role_setting_save_role',
  ROLE_SETTING_CANCEL = 'Role_setting_cancel',
  ROLE_SETTING_TOGGLE_MASTER_GLOBAL_ADMIN = 'Role_setting_toggle_master_global_admin',
  ROLE_SETTING_SELECT_ZONES = 'Role_setting_select_zones',
  ROLE_SETTING_SELECT_SLT = 'Role_setting_select_slt',
  ROLE_SETTING_SELECT_L_ONE = 'Role_setting_select_l_one',
  TALENT_SEARCH_WIZARD_SUBMIT = 'Talent_search_wizard_submit',
  TALENT_SEARCH_WIZARD_STEP_VIEW = 'Talent_search_wizard_step_view',
  TALENT_SEARCH_WIZARD_FILTER_CHANGE = 'Talent_search_wizard_filter_change',
  TALENT_SEARCH_WIZARD_KEYWORD_CHANGE = 'Talent_search_wizard_keyword_change',
  TALENT_SEARCH_WIZARD_JOB_DESCRIPTION_CHANGE = 'Talent_search_wizard_job_description_change',
  TALENT_SEARCH_WIZARD_FILE_CHANGE = 'Talent_search_wizard_file_change',
  TALENT_SEARCH_WIZARD_BACK = 'Talent_search_wizard_back',
  TALENT_SEARCH_WIZARD_RESULTS_FILTER = 'Talent_search_wizard_results_filter',
  TALENT_SEARCH_WIZARD_RESULTS_SORT = 'Talent_search_wizard_results_sort',
  TALENT_SEARCH_WIZARD_RESULTS_PANEL_OPEN = 'Talent_search_wizard_results_panel_open',
  PROCESS_TIMELINE_OPEN_MODULE = 'Process_timeline_open_module',
  PROCESS_TIMELINE_UPDATE_STATUS = 'Process_timeline_update_status',
  TASKS_TODO_MARK_COMPLETE = 'Tasks_todo_mark_complete',
  TASKS_TODO_OPEN_TASK = 'Tasks_todo_open_task',
  TASKS_TODO_OPEN_WATCHLIST = 'Tasks_todo_open_watchlist',
  ELIGIBILITY_CRITERIA_SETUP_ADD_BAND_GROUP = 'Eligibility_criteria_setup_add_band_group',
  ELIGIBILITY_CRITERIA_SETUP_REMOVE_BAND_GROUP = 'Eligibility_criteria_setup_remove_band_group',
  ELIGIBILITY_CRITERIA_SETUP_SELECT_START_DATE = 'Eligibility_criteria_setup_select_start_date',
  ELIGIBILITY_CRITERIA_SETUP_GENERATE_LIST = 'Eligibility_criteria_setup_generate_list',
  ELIGIBILITY_CRITERIA_SETUP_RESET = 'Eligibility_criteria_setup_reset',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_DOWNLOAD_EXCEL = 'Eligibility_criteria_exceptions_download_excel',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_SEARCH_EMPLOYEE = 'Eligibility_criteria_exceptions_search_employee',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_CLEAR_SEARCH = 'Eligibility_criteria_exceptions_clear_search',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_ELIGIBILITY_VIEW_CHANGE = 'Eligibility_criteria_exceptions_eligibility_view_change',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_TOGGLE_FILTERS = 'Eligibility_criteria_exceptions_toggle_filters',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_FILTER_CHANGE = 'Eligibility_criteria_exceptions_filter_change',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_APPLY_FILTERS = 'Eligibility_criteria_exceptions_apply_filters',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_CLEAR_FILTERS = 'Eligibility_criteria_exceptions_clear_filters',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_SORT = 'Eligibility_criteria_exceptions_sort',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_SELECT_EMPLOYEE = 'Eligibility_criteria_exceptions_select_employee',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_SELECT_ALL_EMPLOYEES = 'Eligibility_criteria_exceptions_select_all_employees',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_PAGE_CHANGE = 'Eligibility_criteria_exceptions_page_change',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MASS_ACTION = 'Eligibility_criteria_exceptions_mass_action',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_FILTER_BAND_GROUP_CHANGE = 'Eligibility_criteria_exceptions_filter_band_group_change',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_FILTER_ZONE_CHANGE = 'Eligibility_criteria_exceptions_filter_zone_change',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_FILTER_WORK_COUNTRY_CHANGE = 'Eligibility_criteria_exceptions_filter_work_country_change',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_FILTER_HIRE_DATE_CHANGE = 'Eligibility_criteria_exceptions_filter_hire_date_change',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_FILTER_HIRE_DATE_CLEAR = 'Eligibility_criteria_exceptions_filter_hire_date_clear',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_FILTER_CLEAR_ALL = 'Eligibility_criteria_exceptions_filter_clear_all',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MOBILE_FILTER_CLOSE = 'Eligibility_criteria_exceptions_mobile_filter_close',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MOBILE_FILTER_APPLY = 'Eligibility_criteria_exceptions_mobile_filter_apply',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MOBILE_FILTER_CLEAR = 'Eligibility_criteria_exceptions_mobile_filter_clear',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MASS_ELIGIBILITY_SELECT_YES = 'Eligibility_criteria_exceptions_mass_eligibility_select_yes',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MASS_ELIGIBILITY_SELECT_NO = 'Eligibility_criteria_exceptions_mass_eligibility_select_no',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MASS_ELIGIBILITY_SAVE = 'Eligibility_criteria_exceptions_mass_eligibility_save',
  ELIGIBILITY_CRITERIA_EXCEPTIONS_MASS_ELIGIBILITY_CLOSE = 'Eligibility_criteria_exceptions_mass_eligibility_close',
  NAV_MENU_CLICK = 'Nav_menu_click',
  // Reports - Meeting Details
  MEETING_DETAILS_TOGGLE_FILTERS_REPORT = 'Report_meeting_details_toggle_filters',
  MEETING_DETAILS_SEARCH_REPORT = 'Report_meeting_details_search',
  MEETING_DETAILS_CLEAR_FILTERS_REPORT = 'Report_meeting_details_clear_filters',
  MEETING_DETAILS_APPLY_FILTERS_REPORT = 'Report_meeting_details_apply_filters',
  MEETING_DETAILS_SORT_REPORT = 'Report_meeting_details_sort',
  MEETING_DETAILS_PAGE_CHANGE_REPORT = 'Report_meeting_details_page_change',
  // Reports - My Organization
  MY_ORGANIZATION_TOGGLE_FILTERS_REPORT = 'Report_my_organization_toggle_filters',
  MY_ORGANIZATION_SEARCH_REPORT = 'Report_my_organization_search',
  MY_ORGANIZATION_CLEAR_FILTERS_REPORT = 'Report_my_organization_clear_filters',
  MY_ORGANIZATION_SORT_REPORT = 'Report_my_organization_sort',
  MY_ORGANIZATION_PAGE_CHANGE_REPORT = 'Report_my_organization_page_change',
  MY_ORGANIZATION_DOWNLOAD_DOCUMENTS_REPORT = 'Report_my_organization_download_documents',
  MY_ORGANIZATION_FILTER_CHANGE_REPORT = 'Report_my_organization_filter_change',
  DOWNLOAD_MY_ORGANIZATION_REPORT = 'Download_my_organization_report',
  // Reports - Talent Performance
  TALENT_PERFORMANCE_TOGGLE_FILTERS_REPORT = 'Report_talent_performance_toggle_filters',
  TALENT_PERFORMANCE_SEARCH_REPORT = 'Report_talent_performance_search',
  TALENT_PERFORMANCE_CLEAR_FILTERS_REPORT = 'Report_talent_performance_clear_filters',
  TALENT_PERFORMANCE_SORT_REPORT = 'Report_talent_performance_sort',
  TALENT_PERFORMANCE_PAGE_CHANGE_REPORT = 'Report_talent_performance_page_change',
  TALENT_PERFORMANCE_DOWNLOAD_DOCUMENTS_REPORT = 'Report_talent_performance_download_documents',
  // Reports - Talent Pool
  TALENT_POOL_TOGGLE_FILTERS_REPORT = 'Report_talent_pool_toggle_filters',
  TALENT_POOL_SEARCH_REPORT = 'Report_talent_pool_search',
  TALENT_POOL_CLEAR_FILTERS_REPORT = 'Report_talent_pool_clear_filters',
  TALENT_POOL_SORT_REPORT = 'Report_talent_pool_sort',
  TALENT_POOL_PAGE_CHANGE_REPORT = 'Report_talent_pool_page_change',
  TALENT_POOL_DOWNLOAD_DOCUMENTS_REPORT = 'Report_talent_pool_download_documents',
  DOWNLOAD_TALENT_PERFORMANCE_REPORT = 'Download_talent_performance_report',
  DOWNLOAD_TALENT_POOL_REPORT = 'Download_talent_pool_report',
  // Reports - Talent Search
  TALENT_SEARCH_TOGGLE_FILTERS_REPORT = 'Report_talent_search_toggle_filters',
  TALENT_SEARCH_SEARCH_REPORT = 'Report_talent_search_search',
  TALENT_SEARCH_CLEAR_FILTERS_REPORT = 'Report_talent_search_clear_filters',
  TALENT_SEARCH_APPLY_FILTERS_REPORT = 'Report_talent_search_apply_filters',
  TALENT_SEARCH_SORT_REPORT = 'Report_talent_search_sort',
  TALENT_SEARCH_PAGE_CHANGE_REPORT = 'Report_talent_search_page_change',
  TALENT_SEARCH_DOWNLOAD_DOCUMENTS_REPORT = 'Report_talent_search_download_documents',
  DOWNLOAD_TALENT_SEARCH_REPORT = 'Download_talent_search_report',
  // Reports - OPR
  OPR_TOGGLE_FILTERS_REPORT = 'Report_opr_toggle_filters',
  OPR_SEARCH_REPORT = 'Report_opr_search',
  OPR_CLEAR_FILTERS_REPORT = 'Report_opr_clear_filters',
  OPR_APPLY_FILTERS_REPORT = 'Report_opr_apply_filters',
  OPR_SORT_REPORT = 'Report_opr_sort',
  OPR_PAGE_CHANGE_REPORT = 'Report_opr_page_change',
  OPR_DOWNLOAD_DOCUMENTS_REPORT = 'Report_opr_download_documents',
  DOWNLOAD_OPR_REPORT = 'Download_opr_report',
  // Reports - Meeting Details (Entity Filters)
  MEETING_DETAILS_FILTER_ZONE_REPORT = 'Report_meeting_details_filter_zone',
  MEETING_DETAILS_FILTER_TEMPLATE_REPORT = 'Report_meeting_details_filter_template',
  MEETING_DETAILS_FILTER_YEAR_REPORT = 'Report_meeting_details_filter_year',
  // Reports - Meeting Details (Mobile Filters)
  MEETING_DETAILS_MOBILE_FILTER_CLOSE_REPORT = 'Report_meeting_details_mobile_filter_close',
  MEETING_DETAILS_MOBILE_FILTER_CLEAR_REPORT = 'Report_meeting_details_mobile_filter_clear',
  MEETING_DETAILS_MOBILE_FILTER_APPLY_REPORT = 'Report_meeting_details_mobile_filter_apply',
  // Reports - My Organization (Entity Filters)
  MY_ORGANIZATION_FILTER_STATUS_REPORT = 'Report_my_organization_filter_status',
  MY_ORGANIZATION_FILTER_ABI_ENTITY_REPORT = 'Report_my_organization_filter_abi_entity',
  MY_ORGANIZATION_FILTER_FUNCTION_REPORT = 'Report_my_organization_filter_function',
  MY_ORGANIZATION_FILTER_ZONE_REPORT = 'Report_my_organization_filter_zone',
  MY_ORGANIZATION_FILTER_WORK_COUNTRY_REPORT = 'Report_my_organization_filter_work_country',
  MY_ORGANIZATION_FILTER_BAND_GROUP_REPORT = 'Report_my_organization_filter_band_group',
  MY_ORGANIZATION_FILTER_ELIGIBLE_REPORT = 'Report_my_organization_filter_eligible',
  MY_ORGANIZATION_FILTER_PARTNER_STATUS_REPORT = 'Report_my_organization_filter_partner_status',
  MY_ORGANIZATION_FILTER_MANAGER_CLEAR_REPORT = 'Report_my_organization_filter_manager_clear',
  // Reports - My Organization (Mobile Filters)
  MY_ORGANIZATION_MOBILE_FILTER_CLOSE_REPORT = 'Report_my_organization_mobile_filter_close',
  MY_ORGANIZATION_MOBILE_FILTER_CLEAR_REPORT = 'Report_my_organization_mobile_filter_clear',
  MY_ORGANIZATION_MOBILE_FILTER_APPLY_REPORT = 'Report_my_organization_mobile_filter_apply',
  // Reports - My Organization (Table)
  MY_ORGANIZATION_SELECT_ALL_REPORT = 'Report_my_organization_select_all',
  MY_ORGANIZATION_SELECT_EMPLOYEE_REPORT = 'Report_my_organization_select_employee',
  // Reports - My Organization (Rows)
  MY_ORGANIZATION_OPEN_TALENT_CARD_REPORT = 'Report_my_organization_open_talent_card',
  MY_ORGANIZATION_OPEN_DASHBOARD_REPORT = 'Report_my_organization_open_dashboard',
  // Reports - OPR (Entity Filters)
  OPR_FILTER_STATUS_REPORT = 'Report_opr_filter_status',
  OPR_FILTER_ABI_ENTITY_REPORT = 'Report_opr_filter_abi_entity',
  OPR_FILTER_FUNCTION_REPORT = 'Report_opr_filter_function',
  OPR_FILTER_ZONE_REPORT = 'Report_opr_filter_zone',
  OPR_FILTER_WORK_COUNTRY_REPORT = 'Report_opr_filter_work_country',
  OPR_FILTER_BAND_GROUP_REPORT = 'Report_opr_filter_band_group',
  OPR_FILTER_PARTNER_REPORT = 'Report_opr_filter_partner',
  OPR_FILTER_CURRENT_OPR_REPORT = 'Report_opr_filter_current_opr',
  OPR_FILTER_PREVIOUS_OPR_REPORT = 'Report_opr_filter_previous_opr',
  // Reports - OPR (Mobile Filters)
  OPR_MOBILE_FILTER_CLOSE_REPORT = 'Report_opr_mobile_filter_close',
  OPR_MOBILE_FILTER_CLEAR_REPORT = 'Report_opr_mobile_filter_clear',
  OPR_MOBILE_FILTER_APPLY_REPORT = 'Report_opr_mobile_filter_apply',
  // Reports - OPR (Table)
  OPR_SELECT_ALL_REPORT = 'Report_opr_select_all',
  OPR_SELECT_EMPLOYEE_REPORT = 'Report_opr_select_employee',
  // Reports - Talent Performance (Entity Filters)
  TALENT_PERFORMANCE_FILTER_STATUS_REPORT = 'Report_talent_performance_filter_status',
  TALENT_PERFORMANCE_FILTER_ABI_ENTITY_REPORT = 'Report_talent_performance_filter_abi_entity',
  TALENT_PERFORMANCE_FILTER_FUNCTION_REPORT = 'Report_talent_performance_filter_function',
  TALENT_PERFORMANCE_FILTER_ZONE_REPORT = 'Report_talent_performance_filter_zone',
  TALENT_PERFORMANCE_FILTER_WORK_COUNTRY_REPORT = 'Report_talent_performance_filter_work_country',
  TALENT_PERFORMANCE_FILTER_BAND_GROUP_REPORT = 'Report_talent_performance_filter_band_group',
  TALENT_PERFORMANCE_FILTER_PARTNER_REPORT = 'Report_talent_performance_filter_partner',
  // Reports - Talent Performance (Mobile Filters)
  TALENT_PERFORMANCE_MOBILE_FILTER_CLOSE_REPORT = 'Report_talent_performance_mobile_filter_close',
  TALENT_PERFORMANCE_MOBILE_FILTER_CLEAR_REPORT = 'Report_talent_performance_mobile_filter_clear',
  TALENT_PERFORMANCE_MOBILE_FILTER_APPLY_REPORT = 'Report_talent_performance_mobile_filter_apply',
  // Reports - Talent Performance (Table)
  TALENT_PERFORMANCE_SELECT_ALL_REPORT = 'Report_talent_performance_select_all',
  TALENT_PERFORMANCE_SELECT_EMPLOYEE_REPORT = 'Report_talent_performance_select_employee',
  // Reports - Talent Performance (Rows)
  TALENT_PERFORMANCE_OPEN_TALENT_CARD_REPORT = 'Report_talent_performance_open_talent_card',
  TALENT_PERFORMANCE_OPEN_DASHBOARD_REPORT = 'Report_talent_performance_open_dashboard',
  // Reports - Talent Pool (Entity Filters)
  TALENT_POOL_FILTER_STATUS_REPORT = 'Report_talent_pool_filter_status',
  TALENT_POOL_FILTER_ABI_ENTITY_REPORT = 'Report_talent_pool_filter_abi_entity',
  TALENT_POOL_FILTER_FUNCTION_REPORT = 'Report_talent_pool_filter_function',
  TALENT_POOL_FILTER_ZONE_REPORT = 'Report_talent_pool_filter_zone',
  TALENT_POOL_FILTER_WORK_COUNTRY_REPORT = 'Report_talent_pool_filter_work_country',
  TALENT_POOL_FILTER_BAND_GROUP_REPORT = 'Report_talent_pool_filter_band_group',
  TALENT_POOL_FILTER_PARTNER_YEAR_REPORT = 'Report_talent_pool_filter_partner_year',
  TALENT_POOL_FILTER_CURRENT_NOMINEES_REPORT = 'Report_talent_pool_filter_current_nominees',
  TALENT_POOL_FILTER_TALENT_POOL_YEAR_REPORT = 'Report_talent_pool_filter_talent_pool_year',
  // Reports - Talent Pool (Mobile Filters)
  TALENT_POOL_MOBILE_FILTER_CLOSE_REPORT = 'Report_talent_pool_mobile_filter_close',
  TALENT_POOL_MOBILE_FILTER_CLEAR_REPORT = 'Report_talent_pool_mobile_filter_clear',
  TALENT_POOL_MOBILE_FILTER_APPLY_REPORT = 'Report_talent_pool_mobile_filter_apply',
  // Reports - Talent Pool (Table)
  TALENT_POOL_SELECT_ALL_REPORT = 'Report_talent_pool_select_all',
  TALENT_POOL_SELECT_EMPLOYEE_REPORT = 'Report_talent_pool_select_employee',
  // Reports - Talent Pool (Rows)
  TALENT_POOL_OPEN_TALENT_CARD_REPORT = 'Report_talent_pool_open_talent_card',
  TALENT_POOL_OPEN_DASHBOARD_REPORT = 'Report_talent_pool_open_dashboard',
  // Reports - Talent Search (Entity Filters)
  TALENT_SEARCH_FILTER_STATUS_REPORT = 'Report_talent_search_filter_status',
  TALENT_SEARCH_FILTER_ABI_ENTITY_REPORT = 'Report_talent_search_filter_abi_entity',
  TALENT_SEARCH_FILTER_FUNCTION_REPORT = 'Report_talent_search_filter_function',
  TALENT_SEARCH_FILTER_ZONE_REPORT = 'Report_talent_search_filter_zone',
  TALENT_SEARCH_FILTER_WORK_COUNTRY_REPORT = 'Report_talent_search_filter_work_country',
  TALENT_SEARCH_FILTER_MANAGER_CLEAR_REPORT = 'Report_talent_search_filter_manager_clear',
  TALENT_SEARCH_FILTER_BAND_GROUP_REPORT = 'Report_talent_search_filter_band_group',
  TALENT_SEARCH_FILTER_CAREER_INTEREST_REPORT = 'Report_talent_search_filter_career_interest',
  TALENT_SEARCH_FILTER_MOBILITY_REPORT = 'Report_talent_search_filter_mobility',
  TALENT_SEARCH_FILTER_LANGUAGES_REPORT = 'Report_talent_search_filter_languages',
  TALENT_SEARCH_FILTER_LATEST_RATE_REPORT = 'Report_talent_search_filter_latest_rate',
  TALENT_SEARCH_FILTER_PARTNER_REPORT = 'Report_talent_search_filter_partner',
  // Reports - Talent Search (Mobile Filters)
  TALENT_SEARCH_MOBILE_FILTER_CLOSE_REPORT = 'Report_talent_search_mobile_filter_close',
  TALENT_SEARCH_MOBILE_FILTER_CLEAR_REPORT = 'Report_talent_search_mobile_filter_clear',
  TALENT_SEARCH_MOBILE_FILTER_APPLY_REPORT = 'Report_talent_search_mobile_filter_apply',
  // Reports - Talent Search (Table)
  TALENT_SEARCH_SELECT_ALL_REPORT = 'Report_talent_search_select_all',
  TALENT_SEARCH_SELECT_EMPLOYEE_REPORT = 'Report_talent_search_select_employee',
  // Reports - Talent Search (Rows)
  TALENT_SEARCH_OPEN_TALENT_CARD_REPORT = 'Report_talent_search_open_talent_card',
  TALENT_SEARCH_OPEN_DASHBOARD_REPORT = 'Report_talent_search_open_dashboard',
  // Reports - Talent Search (Mass Actions)
  TALENT_SEARCH_MASS_ACTION_TALENT_CARDS_REPORT = 'Report_talent_search_mass_action_talent_cards',
  TALENT_SEARCH_MASS_ACTION_DASHBOARD_REPORT = 'Report_talent_search_mass_action_dashboard',
  TALENT_SEARCH_MASS_ACTION_TALENT_CARDS_AND_DASHBOARD_REPORT = 'Report_talent_search_mass_action_talent_cards_and_dashboard',
  TALENT_SEARCH_MASS_ACTION_TALENT_CARDS_INDIVIDUALLY_REPORT = 'Report_talent_search_mass_action_talent_cards_individually',
  // Reports - Talent Search (Mobile Mass Actions)
  TALENT_SEARCH_MOBILE_MASS_ACTION_TALENT_CARDS_REPORT = 'Report_talent_search_mobile_mass_action_talent_cards',
  TALENT_SEARCH_MOBILE_MASS_ACTION_DASHBOARD_REPORT = 'Report_talent_search_mobile_mass_action_dashboard',
  TALENT_SEARCH_MOBILE_MASS_ACTION_TALENT_CARDS_AND_DASHBOARD_REPORT = 'Report_talent_search_mobile_mass_action_talent_cards_and_dashboard',
  MEETING_VOTE_NOMINATION = 'Meeting_vote_nomination',
  MEETING_SAVE_AND_CONTINUE = 'Meeting_save_and_continue',
  MEETING_OVERVIEW = 'Meeting_overview',
  MEETING_SHAPES = 'Meeting_shapes',
  MANAGER_ASSESSMENT_SELECT_TURNOVER_RISK = 'Manager_assessment_select_turnover_risk',
  MANAGER_ASSESSMENT_SEARCH_EMPLOYEE = 'Manager_assessment_search_employee',
  MANAGER_ASSESSMENT_SEARCH_MANAGER = 'Manager_assessment_search_manager',
  MANAGER_ASSESSMENT_FILTER_BY_STATUS = 'Manager_assessment_filter_by_status',
  MANAGER_ASSESSMENT_TOGGLE_FULL_TEAM = 'Manager_assessment_toggle_full_team',
  MANAGER_ASSESSMENT_TOGGLE_NOT_ELIGIBLE = 'Manager_assessment_toggle_not_eligible',
  MANAGER_ASSESSMENT_SELECT_EMPLOYEE = 'Manager_assessment_select_employee',
  MANAGER_ASSESSMENT_UNLOCK = 'Manager_assessment_unlock',
  MANAGER_ASSESSMENT_OPR_RATE = 'Manager_assessment_opr_rate',
  MANAGER_ASSESSMENT_PUBLISH = 'Manager_assessment_publish',
  MANAGER_ASSESSMENT_COPY_2AS = 'Manager_assessment_copy_2as',
  MANAGER_ASSESSMENT_CHANGE_COPY_2AS = 'Manager_assessment_change_copy_2as',
  // Feedback Configuration
  FEEDBACK_CONFIG_OPEN_CREATE_DIALOG = 'Feedback_config_open_create_dialog',
  FEEDBACK_CONFIG_CREATE = 'Feedback_config_create',
  FEEDBACK_CONFIG_OPEN_EDIT_DIALOG = 'Feedback_config_open_edit_dialog',
  FEEDBACK_CONFIG_UPDATE = 'Feedback_config_update',
  FEEDBACK_CONFIG_OPEN_DELETE_DIALOG = 'Feedback_config_open_delete_dialog',
  FEEDBACK_CONFIG_DELETE = 'Feedback_config_delete',
}
